import { usePolarGridCells } from "./PolarGridCellsContext";

export function PolarGridCellsViewer() {
    const { svgContent, handleDownload, rings, ringConfigs } = usePolarGridCells();
    const sectorCounts = ringConfigs.map((rc) => Math.max(1, Math.round(rc.sectors)));
    const totalCells = sectorCounts.reduce((sum, n) => sum + n, 0);
    const minSectors = sectorCounts.length ? Math.min(...sectorCounts) : 0;
    const maxSectors = sectorCounts.length ? Math.max(...sectorCounts) : 0;

    return (
        <div className="panel-viewer blob-field-viewer">
            <div className="path-tool-preview">
                <div className="svg-scroll-wrapper">
                    <div
                        className="nested-grid-viewer-svg"
                        // biome-ignore lint/security/noDangerouslySetInnerHtml: SVG is built programmatically
                        dangerouslySetInnerHTML={{ __html: svgContent }}
                    />
                </div>
                <div className="path-tool-footer">
                    <p className="path-tool-meta">
                        {rings} ring{rings !== 1 ? "s" : ""} ·{" "}
                        {totalCells} cell{totalCells !== 1 ? "s" : ""} ·{" "}
                        {minSectors === maxSectors
                            ? `${minSectors} sectors/ring`
                            : `${minSectors}-${maxSectors} sectors/ring`}
                    </p>
                    <button
                        type="button"
                        className="generic-button"
                        onClick={handleDownload}
                    >
                        Download SVG
                    </button>
                </div>
            </div>
        </div>
    );
}
